import { Organization } from '../models';
import { ModelResource } from './resource';
import {
  OrganizationOnboardingStep,
  OrganizationOnboardingStepStatus,
} from '@api/models/organization';

export class Organizations extends ModelResource<Organization> {
  model = Organization;

  resourcePath = 'v1/organizations';

  async updateAuthSettings(
    organization: Organization,
    data: {
      auto_provision_accounts_in_domain: boolean;
      enterprise_auth_connection_name?: string | null;
      is_password_auth_enabled: boolean;
      domains?: string[];
    },
  ): Promise<Organization> {
    const res = await this.api.post(this.path('authentication-settings'), {
      data,
    });

    organization.updateFromJson(res.data);

    return organization;
  }

  async completeOnboardingStep(
    organization: Organization,
    step: OrganizationOnboardingStep,
    data: { status: OrganizationOnboardingStepStatus },
  ): Promise<Organization> {
    const res = await this.api.post(this.path(organization.id, 'onboarding/steps', step), { data });

    organization.updateFromJson(res.data);

    return organization;
  }
}
